document.addEventListener('DOMContentLoaded', function () {
  var input = document.querySelector('[data-customer-logo]');
  var error = document.querySelector('[data-upload-error]');
  if (!input) return;

  var maximumBytes = 10 * 1024 * 1024;

  input.addEventListener('change', function () {
    var file = input.files && input.files[0];
    if (!file || file.size <= maximumBytes) {
      if (error) {
        error.hidden = true;
        error.textContent = '';
      }
      input.setCustomValidity('');
      return;
    }

    input.value = '';
    input.setCustomValidity('Die Datei darf maximal 10 MB groß sein.');
    if (error) {
      error.textContent = 'Die ausgewählte Datei ist größer als 10 MB. Bitte wähle eine kleinere Datei.';
      error.hidden = false;
    }
    input.reportValidity();
  });
});
